'use client';

import dynamic from 'next/dynamic';

export const ProxyPricingCards = dynamic(() => import('./ProxyPricingCards'));
